var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.description))]),_c('img',{attrs:{"src":_vm.currentIcon}})])}
var staticRenderFns = []

export { render, staticRenderFns }